import type { CellContext, ColumnDef } from "@tanstack/react-table";
import { Text } from "@chakra-ui/react";
import { useLocalizedData } from "contexts/LocalizationContext/hooks";
import { SCORE_RANKING_COLORS } from "../../styles";
import type { AirlineScoreTableColumns } from "./AirlineRankingTable.d";
import { NumberCell } from "../../common/Table";

const positionCellCallback = ({
  row: {
    original: { position },
  },
}) => (
  <Text fontSize="sm" as="span">
    {position}.
  </Text>
);

const nameCellCallback = ({
  row: {
    original: { airline },
  },
}) => (
  <Text fontSize="sm" as="span" minW="fit-content" whiteSpace="nowrap">
    {airline}
  </Text>
);

const ScoreCell = ({
  row: {
    original: { score, position },
  },
}: CellContext<AirlineScoreTableColumns, number>) => {
  const { getLocalizedNumber } = useLocalizedData();
  return (
    <Text
      fontSize="sm"
      as="span"
      px={2}
      py={1}
      bg={SCORE_RANKING_COLORS[position]}
      rounded="5px"
      color="inherit"
      maxW="min-content"
      fontWeight="medium"
    >
      {getLocalizedNumber(score, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
    </Text>
  );
};

const columns: ColumnDef<AirlineScoreTableColumns>[] = [
  {
    id: "position",
    header: "",
    accessorKey: "position",
    enableSorting: false,
    cell: positionCellCallback,
  },
  {
    id: "airline",
    header: "airline",
    accessorKey: "airline",
    enableSorting: false,
    cell: nameCellCallback,
  },
  {
    id: "score",
    header: "airhelp_score",
    accessorKey: "score",
    cell: ScoreCell,
  },
  {
    id: "ot_performance",
    header: "on_time_performance",
    accessorKey: "ot_performance",
    cell: NumberCell<AirlineScoreTableColumns>,
  },
  {
    id: "skytrax",
    header: "customer_opinion",
    accessorKey: "skytrax",
    cell: NumberCell<AirlineScoreTableColumns>,
  },
  {
    id: "claim_processing_score",
    header: "claim_processing",
    accessorKey: "claim_processing_score",
    cell: NumberCell<AirlineScoreTableColumns>,
  },
];

export default columns;
